// Copyright (c) 2020 Deere & Company

import { fetch as deereFetch } from '@deere/cps-it.fetch-wrapper';
import { getEnvironment } from './common-functions';
import store from '../../../store';

const headerOptions = accessToken => ( {
    Authorization: accessToken ? `Bearer ${accessToken}` : ''
} );

const generalContent = options => {

    const language = 'EN';
    const state = store.getState();
    const { accessToken } = state.oktaState.oktaState;
    const { unit } = state.application;
    const optionHeader = options.headers;
    const optionCopy = options;
    const env = getEnvironment();
    const headerWithToken = {
        ...headerOptions( accessToken ),
        Unit: unit.name ? unit.name : '',
        skipfilter: !!( env === 'LOCAL' || env === 'TAL' ),
        'Accept-Language': language
    };
    const headers = optionHeader ? Object.assign( headerWithToken, optionHeader ) : headerWithToken;

    if ( optionHeader ) {

        delete ( optionCopy.headers );

    }

    const fetchOptions = {
        headers,
        ...optionCopy
    };

    return ( fetchOptions );

};

export async function fetch ( input, options ) {

    const fetchOptions = generalContent( options );

    return deereFetch( input, fetchOptions );

}

export async function fetchforFileUpload ( input, options ) {

    const fetchOptions = generalContent( options );

    fetchOptions.credentials = fetchOptions.credentials || 'same-origin';

    const request = global.fetch( input, fetchOptions );

    return request.then( response => {

        if ( !response.ok ) {

            return Promise.reject( response );

        }

        return response;

    } );

}

export function anonFetch ( input, options ) {

    return deereFetch( input, options );

}
